module.exports = __webpack_public_path__ + "img/wire-4.7f4d966e.jpg";